import type { LightingManager } from '../lighting-manager.class';
import { DEFAULT_LIGHTING_PRESET } from '../types';

/**
 * Restores all scene light intensities to their default preset values.
 *
 * Called when switching away from a custom sky texture so that built-in
 * sky presets render with the standard lighting configuration.
 */
export const restoreDefaultBrightnessCfn = (self: LightingManager, _params: Record<string, never>): void => {
	const ambientLight = self.internalAmbientLight;
	if (ambientLight) {
		ambientLight.intensity = DEFAULT_LIGHTING_PRESET.ambient.intensity;
	}

	const directionalLight = self.internalDirectionalLight;
	if (directionalLight) {
		directionalLight.intensity = DEFAULT_LIGHTING_PRESET.directional.intensity;
	}

	const hemisphereLight = self.internalHemisphereLight;
	if (hemisphereLight) {
		hemisphereLight.intensity = DEFAULT_LIGHTING_PRESET.hemisphere.intensity;
	}

	const { scene } = self.internalConfig;
	if (scene) {
		scene.environmentIntensity = 1.0;
		scene.backgroundIntensity = 1.0;
	}
};
